import { ArrowRight } from "lucide-react";

import type { Recipe } from "@/features/recipes/types";
import { plural } from "@/lib/format";

type RecipeListItemProps = {
  recipe: Recipe;
  /** What this recipe produces — the point of the recipe. */
  productName?: string;
  subtitle?: string;
  onClick: () => void;
};

export function RecipeListItem({ recipe, productName, subtitle, onClick }: RecipeListItemProps) {
  const count = recipe.ingredients?.length ?? 0;

  return (
    <button
      type="button"
      onClick={onClick}
      className="flex w-full items-center gap-4 rounded-xl border border-border bg-card p-4 text-left transition hover:bg-muted/50"
    >
      <span className="flex min-w-0 flex-1 flex-col">
        <span className="truncate text-[15px] font-semibold">{recipe.name}</span>

        {productName ? (
          <span className="mt-0.5 flex items-center gap-1.5 text-sm text-muted-foreground">
            <ArrowRight size={14} aria-hidden />
            fabrique <span className="font-medium text-foreground">{productName}</span>
          </span>
        ) : null}

        <span className="mt-1 text-[13px] text-muted-foreground">
          {count} {plural(count, "matière première", "matières premières")}
          {subtitle ? ` · ${subtitle}` : ""}
        </span>
      </span>
    </button>
  );
}
